import React from 'react';
import { SocialIconStyles } from '../SelectIcon';

export const Linkedin = props => (
  <svg
    style={SocialIconStyles}
    aria-label="Linkedin"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 430.1 430.1"
  >
    <path
      fill={props.color}
      d="M430.1 261.5v159H338V272.3c0-37.3-13.3-62.7-46.7-62.7-25.4 0-40.6 17.1-47.3 33.7a63 63 0 0 0-3 22.5v154.9h-92.3s1.3-251.3 0-277.4H241v39.3l-.6 1h.6v-1c12.2-18.8 34-45.8 83-45.8 60.7 0 106.2 39.7 106.2 124.8zm-378-252C20.7 9.6 0 30.4 0 57.6c0 26.6 20 47.9 51 47.9h.6c32.1 0 52.1-21.3 52.1-48-.6-27.1-20-47.8-51.5-47.8zm-46.6 411h92.2V143.3H5.5v277.4z"
    />
  </svg>
);

export default Linkedin;



// WEBPACK FOOTER //
// ./src/components/UI/Img/SocialIconsSVG/Linkedin.jsx